import keyMirror from 'keymirror'

export { AttachmentTypes, Services } from '~publish/legacy/constants'

export { NotificationTypes, NotificationScopes } from './values/Notification'

export const LinkAttachmentTextFieldTypes = keyMirror({
  TITLE: null,
  DESCRIPTION: null,
})

export const ErrorTypes = keyMirror({
  INLINE: null,
  FLOATING: null,
})

/**
 * Error codes returned by the Buffer API that should route to a FLOATING
 * notification scope rather than an INLINE notification scope tied to a
 * specific service. FLOATING is intended for service-agnostic errors
 * (auth, rate limits, infrastructure, malformed request). Everything NOT
 * in this list routes to `UPDATE_SAVING-INLINE-<serviceName>` so the
 * error renders next to the affected channel via `useSavingError`.
 *
 * Heads up: there is currently no consumer of the FLOATING scope. Adding
 * a code to this list today effectively silences the error for the user.
 * Only add codes that genuinely cannot be attributed to a single service.
 *
 * Full table of API error codes in buffer-web:
 * https://github.com/bufferapp/buffer-web/blob/f6fab9bace228bf7f1c343a8c5c5cc0c7b1a0f1d/app/views/developers/api/errors.php
 *
 * `1003` ("Parameter not recognized" per the docs) is deliberately NOT
 * in this list: the backend has historically reused it for per-service
 * media validation errors (e.g. "video file too large for TikTok"),
 * which should surface inline next to the affected channel. See
 * CONT-1945.
 */
export const FloatingErrorCodes = [
  401, // Unauthorized
  403, // Permission denied
  404, // Endpoint not found
  405, // Method not allowed
  429, // Too Many Requests (rate limited)
  1000, // An unknown error occurred
  1001, // Access token required
  1002, // Not within application scope
  1005, // Unsupported response format
  1006, // Parameter value not within bounds
  1007, // An existing matching record has been found
  1042, // User did not save successfully
  1050, // Client could not be found
  1051, // No authorization to access client
]

export const UpgradeErrorCodes = {
  queueLimit: 1023, // Reached profile queue limit
}

export const ComposerInitiators = {
  ImageBufferButtons: ['hover_button_image', 'menu-image'],
}

export const QueueingTypes = {
  NEXT: 'NEXT',
  QUEUE: 'QUEUE',
  NOW: 'NOW',
  CUSTOM: 'CUSTOM',
  SAVE: 'SAVE',
  ADD_DRAFT: 'ADD_DRAFT',
  NEXT_DRAFT: 'NEXT_DRAFT',
  CUSTOM_DRAFT: 'CUSTOM_DRAFT',
  RECOMMENDED: 'RECOMMENDED',
} as const

export const AsyncOperationStates = keyMirror({
  PENDING: null,
  DONE: null,
})

export const VideoThumbnailMaxSize = 500

export const COMPOSER_ERROR_CODE = {
  MISSING_PROFILE: 'MISSING_PROFILE',
  PROCESSING: 'PROCESSING',
  ALREADY_SAVED: 'ALREADY_SAVED',
  SCHEDULE_IN_THE_PAST: 'SCHEDULE_IN_THE_PAST',
  NOT_ENABLED: 'NOT_ENABLED',
  NO_PERMISSION: 'NO_PERMISSION',
} as const
